import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";
import WhatsAppAccountSettings from "./WhatsAppAccountSettings";
import WhatsAppCampaigns from "./WhatsAppCampaigns";
import WhatsAppChats from "./WhatsAppChats";

// A WhatsApp-style chat list + open-chat view (which absorbs what used to be
// three separate tabs — Groups, Send Message, History), plus two admin-only
// tabs: raw-number Campaigns and the connected-account settings.
const BASE_TABS = [{ key: "chats", label: "Chats" }];
// Only an admin can blast raw, unverified numbers — bypasses every
// class/instructor scoping check that group sends go through.
const CAMPAIGNS_TAB = { key: "campaigns", label: "Campaigns" };
// Only an admin manages the connected WhatsApp Business Account — an
// instructor sends messages but never touches the school's credentials.
const ACCOUNT_TAB = { key: "account", label: "Account" };

/**
 * Shared by the admin and instructor shells. The only thing that differs is the
 * route prefix — every backend endpoint this screen calls is already scoped by
 * the caller's role, so there is nothing role-specific to branch on here,
 * except which tabs are visible.
 */
const SwitchWhatsApp = ({ basePath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(selectUser);

  const tabs =
    user?.role === "admin" ? [...BASE_TABS, CAMPAIGNS_TAB, ACCOUNT_TAB] : BASE_TABS;

  const last = location.pathname.split("/").pop();
  const currentTab = tabs.some((t) => t.key === last) ? last : "chats";

  return (
    <div className="p-8">
      <div
        className="bg-white rounded-lg"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
        }}
      >
        {tabs.map(({ key, label }) => (
          <div
            key={key}
            onClick={() => navigate(`${basePath}/${key}`)}
            className={`iskool-tab-item ${
              currentTab === key ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">{label}</div>
          </div>
        ))}
      </div>

      {/* Every panel stays mounted so a half-typed message survives a tab switch. */}
      <div style={{ display: currentTab === "chats" ? "block" : "none" }}>
        <WhatsAppChats />
      </div>
      {user?.role === "admin" && (
        <>
          <div style={{ display: currentTab === "campaigns" ? "block" : "none" }}>
            <WhatsAppCampaigns />
          </div>
          <div style={{ display: currentTab === "account" ? "block" : "none" }}>
            <WhatsAppAccountSettings />
          </div>
        </>
      )}
    </div>
  );
};

export default SwitchWhatsApp;
